import { __ } from '@wordpress/i18n';
import {
	useBlockProps,
	InspectorControls,
	MediaUpload,
	MediaUploadCheck,
	MediaPlaceholder,
	BlockControls,
	RichText,
} from '@wordpress/block-editor';
import {
	PanelBody,
	Button,
	TextControl,
	TextareaControl,
	ToolbarGroup,
	ToolbarButton,
} from '@wordpress/components';
import { useState, useEffect } from '@wordpress/element';
// import Inspector from './inspector';
import Style from './Style';

import blockJson from './block.json';

export default function Edit( props ) {
	const { attributes, setAttributes, className, isSelected, clientId } =
		props;
	const {
		mediaImage,
		altText,
		caption,
		width,
		height,
		title,
		imageObjectFit,
		onHoverImage,
		imageMaskShape,
		enableImageCaption,
		captionAlignment,
		enableOverlay,
		overlayBackgroundColor,
		overlayText,
		overlayOpacity,
		enableText,
		blockId,
	} = attributes;

	useEffect( () => {
		setAttributes( { blockId: clientId } );
	}, [ clientId ] );

	const blockProps = useBlockProps( {
		className: `alpha-image-blocks alpha-image-block-${ blockId } ${ onHoverImage } ${ imageMaskShape }`,
	} );

	const onSelectImage = ( media ) => {
		setAttributes( {
			mediaImage: {
				id: media.id,
				url: media.url,
				alt: media.alt,
			},
			altText: media.alt,
			title: media.title,
		} );
	};

	const onSelectURL = ( url ) => {
		setAttributes( { mediaImage: { id: null, url, alt: '' } } );
	};

	const imageUrl = mediaImage?.url || '';

	return (
		<div { ...blockProps }>
			<Style { ...props } />
			{ isSelected && (
				<window.InspectorGenerator props={ props } blockJson={ blockJson } />
			) }
			<BlockControls>
				<ToolbarGroup>
					<MediaUploadCheck>
						<MediaUpload
							onSelect={ onSelectImage }
							allowedTypes={ [ 'image' ] }
							value={ imageUrl }
							render={ ( { open } ) => (
								<ToolbarButton onClick={ open }>
									{ __( 'Replace Image', 'alpha-blocks' ) }
								</ToolbarButton>
							) }
						/>
					</MediaUploadCheck>
				</ToolbarGroup>
			</BlockControls>
			{ ! imageUrl ? (
				<MediaPlaceholder
					onSelect={ onSelectImage }
					allowedTypes={ [ 'image' ] }
					onSelectURL={ onSelectURL }
					icon="format-image"
					labels={ {
						title: __( 'Image', 'alpha-blocks' ),
						instructions: __(
							'Upload an image, pick one from your media library, or add one with a URL.',
							'alpha-blocks'
						),
					} }
				/>
			) : (
				<>
					<div style={ { position: 'relative' } }>
						{ enableOverlay && (
							<div
								className="overlay"
								style={ {
									backgroundColor:
										overlayBackgroundColor?.color,
									backgroundImage:
										overlayBackgroundColor?.gradient,
									position: 'absolute',
									width: '100%',
									height: '100%',
									zIndex: '99',
									opacity: overlayOpacity.desktop.val / 100,
									display: 'flex',
									alignItems: 'center',
								} }
							>
								{ enableText && (
									<RichText
										tagName="p"
										value={ overlayText }
										onChange={ ( value ) =>
											setAttributes( {
												overlayText: value,
											} )
										}
										placeholder={ __(
											'Write overlay text…',
											'alpha-blocks'
										) }
										className={ 'overlay-text' }
									/>
								) }
							</div>
						) }
						<img
							src={ imageUrl }
							alt={ altText }
							title={ title }
							style={ { objectFit: imageObjectFit } }
							className={ imageMaskShape }
						/>
					</div>
					{ enableImageCaption && (
						<TextareaControl
							value={ caption }
							onChange={ ( value ) =>
								setAttributes( { caption: value } )
							}
							placeholder={ __(
								'Write caption…',
								'alpha-blocks'
							) }
							style={ {
								textAlign: captionAlignment,
								height: '50px',
								marginTop: 0,
							} }
						/>
					) }
				</>
			) }
		</div>
	);
}
